// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Naive way of hiding the debug widget when the debug functionality is disabled https://github.com/arduino/arduino-ide/issues/14 */
.theia-debug-container .debug-toolbar.hidden,
.theia-debug-container .theia-session-container.hidden {
    visibility: hidden;
}

.theia-debug-container .status-message {
    font-family: "Open Sans";
    font-style: normal;
    font-size: 12px;

    padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/debug.css"],"names":[],"mappings":"AAAA,mIAAmI;AACnI;;IAEI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;;IAEf,aAAa;AACjB","sourcesContent":["/* Naive way of hiding the debug widget when the debug functionality is disabled https://github.com/arduino/arduino-ide/issues/14 */\r\n.theia-debug-container .debug-toolbar.hidden,\r\n.theia-debug-container .theia-session-container.hidden {\r\n    visibility: hidden;\r\n}\r\n\r\n.theia-debug-container .status-message {\r\n    font-family: \"Open Sans\";\r\n    font-style: normal;\r\n    font-size: 12px;\r\n\r\n    padding: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
